import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setBreadcrumb } from '../actions/breadcrumb'
import { fetchQuotes, fetchDetailsQuote, resetQuotes } from '../actions/quotes'
import { updateMode, setDropoff } from '../actions/shipback'

import { POSTAL, DROPOFF, PICKUP, RETURNS, SHIPPING, CHECKOUT, UNKNOWN, COMPUTED } from '../assets/constant'

import Mode from './Mode'
import Pickup from './Pickup'
import Dropoff from './Dropoff'
import DropoffModal from './DropoffModal'

import { isEmpty } from '../assets/utils'


class ReturnModes extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.goToCheckout = this.goToCheckout.bind(this)
    this.setMode = this.setMode.bind(this);
    this.refreshQuotes = this.refreshQuotes.bind(this)
    this.setDisplay = this.setDisplay.bind(this);
    this.setDropoff = this.setDropoff.bind(this)
    this.resetDropoff = this.resetDropoff.bind(this)
    this.submit = this.submit.bind(this)
    this.quotesAvailable = this.quotesAvailable.bind(this)
    this.quoteAvailable = this.quoteAvailable.bind(this)
    this.displayError = this.displayError.bind(this)
    this.clear = this.clear.bind(this)
    this.clearIntervals = this.clearIntervals.bind(this)
    this.clearTimeouts = this.clearTimeouts.bind(this)
    this.state = { mode: POSTAL, display: false, dropoffIndex: 1, flash: "", error: null, sentry: false, intervals: [], timeouts: [] }
  }

  componentWillMount() {
    this.setState({sentry: false})
    if (this.props.breadcrumb == SHIPPING) {
      this.props.fetchQuotes(shipback_id, this.props.user_token)
      var interval = setInterval(() => {this.refreshQuotes()}, 5000)
      var timeout = setTimeout(() => { this.setDisplay() }, 90000)
      this.setState({ timeouts: [...this.state.timeouts, timeout], intervals: [...this.state.intervals, interval] })
    }
  }

  componentWillUnmount(){
    this.props.resetQuotes()
    this.setState({ display: false })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.customer != this.props.customer) {
      this.props.resetQuotes()
      if (this.state.display) {
        this.setState({ display: false })
      }
      var interval = setInterval(() => {this.refreshQuotes()}, 5000)
      var timeout = setTimeout(() => { this.setDisplay() }, 90000)
      this.setState({ timeouts: [...this.state.timeouts, timeout], intervals: [...this.state.intervals, interval] })
    }
  }

  refreshQuotes() {
    if (this.props.quotes != undefined && this.props.quotes.length > 0) {
      if (this.quotesAvailable()) {
        if (!isEmpty(this.state.availableQuote) && this.props.shipback.mode == UNKNOWN) {
          this.props.updateMode(this.state.availableQuote.mode, shipback_id, this.props.user_token)
        }
        this.clear()
      } else {
        this.props.fetchQuotes(shipback_id, this.props.user_token)
      }
    }
    else {
      this.props.fetchQuotes(shipback_id, this.props.user_token)
    }
  }

  setDisplay() {
    if (!this.quotesAvailable() && this.state.availableQuote == undefined) {
      this.setState({sentry: true})
      this.clearTimeouts()
      this.clearIntervals()
      Raven.captureMessage("No modes after timeout for shipback #" + shipback_id, {level: 'error'});
    } else {
      this.clear()
    }
  }

  clear() {
    this.setState({ display: true })
    this.clearTimeouts()
    this.clearIntervals()
  }

  clearTimeouts() {
    for (var i = 0 ; i < this.state.timeouts.length; i ++) {
      var timeout = this.state.timeouts[i]
      clearTimeout(timeout)
    }
  }

  clearIntervals() {
    for (var i = 0 ; i < this.state.intervals.length; i ++) {
      var interval = this.state.intervals[i]
      clearInterval(interval)
    }
  }

  isAvailableMode(mode) {
    for (var i = 0 ; i < this.props.shipback.quotes.length; i ++) {
      var quote = this.props.shipback.quotes[i]
      if (quote.mode == mode && quote.available) {
        return true
      }
    }
    return false
  }


  submit() {
    if (this.isAvailableMode(this.props.shipback.mode)) {
      switch(this.props.shipback.mode) {
        case POSTAL:
          this.goToCheckout()
        case PICKUP:
          if (this.props.shipback.pickup_datetime != null) {
             this.goToCheckout()
          } else {
            this.displayError()
          }
        case DROPOFF:
          if (this.props.shipback.dropoff_code != null) {
            this.goToCheckout()
          } else {
            this.displayError()
          }
      }
    }
  }

  displayError() {
    var error = "shipbacks.modes." + this.props.shipback.mode +"s.update.error"
    this.setState({ flash: "flash error", error: error })
  }
  goToCheckout() {
    this.props.setBreadcrumb(CHECKOUT)
  }

  setMode(mode) {
    this.props.fetchDetailsQuote(shipback_id, mode, this.props.user_token)
    this.props.updateMode(mode, shipback_id, this.props.user_token)
    this.setState({ mode: mode, flash: null, error: "" })
  }

  setDropoff(dropoff, index) {
    this.setState({ dropoff: dropoff, dropoffIndex: index + 1 })
  }

  resetDropoff() {
    this.setState({ dropoff: null })
  }

   quoteAvailable(mode) {
    for (var i = 0; i < this.props.quotes.length; i++) {
      var quote = this.props.quotes[i]
      if (quote.mode == mode) {
        if (quote.state == COMPUTED) {
          return true
        }
      }
    }
    return false
  }

  quotesAvailable() {
    var j = 0
    for (var i = 0; i < this.props.quotes.length; i++) {
      var quote = this.props.quotes[i]
        if (quote.available) {
          this.setState({availableQuote: quote})
        }
        if (quote.state == COMPUTED || quote.available){
          j++
        }
    }
    return j == this.props.quotes.length
  }

  renderModes() {
    if (this.props.shipback.mode != UNKNOWN && this.quoteAvailable(this.props.shipback.mode)) {
      switch(this.props.shipback.mode) {
        case POSTAL:
          return <div></div>
        case PICKUP:
          return <Pickup />
        case DROPOFF:
          return (
            <div className="dropoff-selection">
              <Dropoff selectedDropoff={this.state.dropoff} setDropoff={this.setDropoff} />
              <DropoffModal selectedDropoff={this.state.dropoff} setDropoffFromMap={this.setDropoff} dropoffIndex={this.state.dropoffIndex} resetDropoff={this.resetDropoff} />
            </div>
          )
        default:
          break;
      }
    }
  }

  render() {
    var submitClass = 'submit pull-right'
    if (!this.isAvailableMode(this.props.shipback.mode)) {
      submitClass += ' disabled'
    }
    if (this.state.sentry == true) {
      return (
        <div className="sentry" onClick={() => Raven.lastEventId() && Raven.showReportDialog()}>
          <img src={sentry_logo} className="img-fluid"/>
          <p>{I18n.t('sentry.message')}</p>
          <p className="action">{I18n.t('sentry.action')}</p>
        </div>
      )
    }
    else {
      if (this.state.display == true &&  this.state.sentry == false && !isEmpty(this.props.quotes)) {
        return (
          <div className="row modes">
            <div className={this.state.flash}>
              <span>{this.state.error ? I18n.t(this.state.error) : ""}</span>
            </div>
            <div className="col-10 offset-1">
              <h2>{I18n.t('shared.select_mode.title')}</h2>
              <div className="row">
                {
                 this.props.quotes.map((quote) => (
                  quote.available == true ?
                    <Mode
                      key={quote.mode}
                      quote={quote}
                      current_mode={this.props.shipback.mode != UNKNOWN ? this.props.shipback.mode : this.state.mode}
                      setMode={this.setMode} />
                    :
                    <div key={quote.mode}></div>
                ))
               }
              </div>
              {this.renderModes()}
              <a href="#" className={submitClass} onClick={this.submit}>{I18n.t('shipbacks.items.show.submit')}</a>
            </div>

          </div>
        )
      } else {
        return (
          <div className="spinner">
            <div className="col-12">
              <i className="fa-li fa fa-3x fa-spinner fa-spin"/>
              <h3>
                <span dangerouslySetInnerHTML={{__html: I18n.t('shipbacks.modes.show.instructions_html')}}></span>
              </h3>
            </div>
          </div>
        )
      }
    }
  }
}

const mapStateToProps = state => ({
  shipback: state.shipback,
  quotes: state.quotes.quotes,
  breadcrumb: state.breadcrumb,
  dropoff: state.quotes.dropoff,
  pickup: state.quotes.pickup,
  postal: state.quotes.dropoff,
  user_token: state.user,
  customer: state.customer,
})

const mapDispatchToProps = dispatch => bindActionCreators({ setBreadcrumb, fetchQuotes, fetchDetailsQuote , updateMode, setDropoff, resetQuotes }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ReturnModes)


// WEBPACK FOOTER //
// ./app/javascript/components/components/ReturnModes.jsx